import "../styles.css"
export const Join =()=>{
    return (
        <div className="join-main">
            <div className="join">
                <img src="https://www.licious.in/img/rebranding/loyalty_licious_logo.svg" alt="licious" />
                <button className="join-btn">Join Now</button>
            </div>
            <hr />
            <div>
                <p className="join-p">Enjoy unlimited free delivery & perks crafted for true meat lovers</p>
            </div>
        </div>
    )
}